import React, { useState, useEffect } from "react";
import { Grid, Paper, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import ieqipCoreServiceApi from "../../../apis/ieqipCoreServiceApi";
import { useSelector } from "react-redux";
import { handleDownloadFileFromS3 } from "../../../utilities/helpers";
import documentApi from "../../../apis/documentApi";

const ExhibitionReport = ({ inspectionUid, inspectionExhibitions }) => {
  const [exhibitions, setExhibitions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const tenantId = useSelector((state) => state.tenantId);
  const idToken = useSelector((state) => state.token);

  useEffect(() => {
    if (inspectionExhibitions) {
      setExhibitions(inspectionExhibitions);
    } else {
      fetchExhibitions();
    }
    // eslint-disable-next-line
  }, [inspectionUid, inspectionExhibitions]);

  const fetchExhibitions = async () => {
    try {
      setLoading(true);
      setError(null);
      const requestHeader = {
        headers: {
          "x-eqip-tenantid": tenantId,
          "Authorization": idToken
        },
      };
      const response = await ieqipCoreServiceApi.get(`/api/inspections/${inspectionUid}/inspectionexhibitions`, requestHeader);

      if (response.data && Array.isArray(response.data)) {
        setExhibitions(response.data);
      } else {
        setExhibitions([]);
      }
    } catch (error) {
      console.error("Error fetching exhibitions:", error);
      setError("Failed to load exhibitions");
      setExhibitions([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null;
  }

  if (error) {
    return null;
  }

  if (!exhibitions.length) {
    return null;
  }

  const handleDownloadFile = async (exhibition) => {
    setLoading(true);
    try {
      // exhibition.description is /documents/presignedurldownload?objectKey=SH0006/b5dccb03-d345-4ba1-9584-b3c9d7ea5810
      // Construct the object key using the reference code and document_uid
      const objectKey = `${exhibition.description.split('=')[1].split('/')[0]}/${exhibition.description.split('=')[1].split('/')[1]}`;
      await handleDownloadFileFromS3(documentApi, objectKey, exhibition.code, '/documents/presignedurldownload');
    } catch (error) {
      console.error('Download failed:', error);
      const errorMessage = error.response?.data?.message ||
        error.response?.data?.error ||
        error.response?.data?.detail ||
        error.message ||
        'Failed to download file. Please try again.';
      alert(errorMessage);
    }
    setLoading(false);
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="50">#</TableCell>
                <TableCell width="200">Title</TableCell>
                <TableCell>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {exhibitions.map((exhibition, index) => (
                <TableRow key={exhibition.inspection_exhibition_uid}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{exhibition.code}</TableCell>
                  {!exhibition.description.includes('presignedurl') ? 
                  <TableCell>
                    <Box sx={{
                      '& p': { margin: 0 },
                      '& *': { maxWidth: '100%' }
                    }}
                      dangerouslySetInnerHTML={{ __html: exhibition.description || '' }}
                    />
                  </TableCell> 
                  : 
                  <TableCell>                            
                    <Typography
                    component="span"
                    sx={{
                      color: 'primary.main',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      '&:hover': {
                        color: 'primary.dark'
                      }
                    }}
                    onClick={() => handleDownloadFile(exhibition)}
                  >
                    {exhibition.code}
                  </Typography></TableCell>}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default ExhibitionReport; 